module.exports = __webpack_public_path__ + "assets/img/tongue-hit.3be3e64f.png";